import * as React from 'react';
import { TFooter } from './Footer.types';
import { Facebook, Instagram, LinkedIn, Twitter } from '@mui/icons-material';
import './Footer.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const Footer: TFooter = () => {
  const localize = useLocalize();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__section footer__section--about">
          <h3 className="footer__title">
            {localize('footer.section.about.title')}
          </h3>
          <p className="footer__text">
            {localize('footer.section.about.text')}
          </p>
        </div>

        <div className="footer__section footer__section--links">
          <h3 className="footer__title">
            {localize('footer.section.quick.links.title')}
          </h3>
          <ul className="footer__links">
            <li className="footer__link">
              <a href="#courses" className="footer__link-item">
                {localize('footer.link.courses')}
              </a>
            </li>
            <li className="footer__link">
              <a href="#about" className="footer__link-item">
                {localize('footer.link.about.us')}
              </a>
            </li>
            <li className="footer__link">
              <a href="#contact" className="footer__link-item">
                {localize('footer.link.contact')}
              </a>
            </li>
            <li className="footer__link">
              <a href="#support" className="footer__link-item">
                {localize('footer.link.support')}
              </a>
            </li>
          </ul>
        </div>

        <div className="footer__section footer__section--social">
          <h3 className="footer__title">
            {localize('footer.section.follow.title')}
          </h3>
          <div className="footer__social-icons">
            <a
              href="https://facebook.com"
              className="footer__social-icon"
              aria-label={localize('footer.aria.facebook') as string}
            >
              <Facebook />
            </a>
            <a
              href="https://instagram.com"
              className="footer__social-icon"
              aria-label={localize('footer.aria.instagram') as string}
            >
              <Instagram />
            </a>
            <a
              href="https://twitter.com"
              className="footer__social-icon"
              aria-label={localize('footer.aria.twitter') as string}
            >
              <Twitter />
            </a>
            <a
              href="https://linkedin.com"
              className="footer__social-icon"
              aria-label={localize('footer.aria.linkedin') as string}
            >
              <LinkedIn />
            </a>
          </div>
        </div>

        <div className="footer__section footer__section--contact">
          <h3 className="footer__title">
            {localize('footer.section.contact.title')}
          </h3>
          <p className="footer__text">{localize('footer.contact.address')}</p>
          <p className="footer__text">
            {localize('footer.contact.email.label')}{' '}
            <a href="mailto:support@courses.com" className="footer__link-item">
              support@courses.com
            </a>
          </p>
          <p className="footer__text">{localize('footer.contact.phone')}</p>
        </div>
      </div>

      <div className="footer__bottom">
        <p className="footer__bottom-text">
          {localize('footer.bottom.copyright')}
        </p>
      </div>
    </footer>
  );
};
